import { takeLatest, put, call, select } from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import map from 'lodash/map';
import {
    getFinancing,
    patchFinancing,
    postRewardOrFinancing,
} from 'yoda-interfaces/lib/Order/OrderApi';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import {
    URL_REVIEW_PAGE,
    ADJUSTMENT_TYPE_NEW_CUSTOMER,
} from 'yoda-checkout-components/lib/common/Constants';
import { DELETE_REWARD_REQUEST_SUCCESS } from 'yoda-checkout-components/lib/actionTypes/RewardsActionTypes';
import showGlobalLoader from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import * as PlaceOrderActions from 'yoda-checkout-components/lib/actions/PlaceOrderActions';
import * as cartActions from '../actions/GetCartDetailsAction';
import * as paymentActionTypes from '../actionTypes/PaymentActionTypes';
import * as paymentAction from '../actions/PaymentAction';
import { addCreditCardToOrderErrorHandler } from './NewPaymentSaga';

const orderDetailsSelector = (state) => state.orderDetails;

const reviewPage = () => ({ nextPage: URL_REVIEW_PAGE });

function* getPromoFinancingSaga(action) {
    try {
        const isRequestFromReviewPage = window.location.pathname === URL_REVIEW_PAGE;
        const result = yield call(FactorySaga, getFinancing, action);
        if (result.isSuccess) {
            const promoFinancingResponse = result.response.data;
            yield put({
                type: paymentActionTypes.GET_PROMO_FINANCING_OFFERS_SUCCESS,
                promoFinancingResponse,
            });

            if (
                !isRequestFromReviewPage &&
                get(promoFinancingResponse, 'options.length', 0) === 0
            ) {
                yield put(cartActions.getCartDetails(reviewPage()));
                yield put(paymentAction.setRewardPromoFinanceDecisionData({}));
            } else {
                yield put(showGlobalLoader(false));
            }
        } else if (!isRequestFromReviewPage) {
            yield put(cartActions.getCartDetails(reviewPage()));
        } else {
            yield put(showGlobalLoader(false));
        }
    } catch (error) {
        yield put(showGlobalLoader(false));
    }
}

const watchGetPromoFinancingSaga = function* watchGetPromoFinancingSaga() {
    yield takeLatest(paymentActionTypes.GET_PROMO_FINANCING_OFFERS, getPromoFinancingSaga);
};
watchGetPromoFinancingSaga.sagaName = 'watchGetPromoFinancingSaga';

function* patchSelectedPromoFinancingSaga(action) {
    try {
        const modifyAction = action;
        const { isPromoFinaceOfferDeclined } = modifyAction;
        if (isPromoFinaceOfferDeclined) delete modifyAction.isPromoFinaceOfferDeclined;
        const result = yield call(FactorySaga, patchFinancing, modifyAction);
        if (result.isSuccess) {
            if (window.location.pathname === URL_REVIEW_PAGE) {
                // If user is already in the review page then just refresh the content
                // to reflect the selection made by the user
                yield put(cartActions.getCartDetails());
            } else {
                // If user is in payment page redirect to the review page
                yield put(
                    cartActions.getCartDetails({ nextPage: URL_REVIEW_PAGE, pageName: 'review' })
                );
            }
            const promoFinanceData = {
                isSpecialFinancingSelected: !isPromoFinaceOfferDeclined,
            };
            yield put(paymentAction.setRewardPromoFinanceDecisionData(promoFinanceData));
        } else {
            yield put(PlaceOrderActions.resetPromoFinancingData());
            yield call(addCreditCardToOrderErrorHandler, result);
        }
    } catch (error) {
        yield put(cartActions.getCartDetails(reviewPage()));
    }
}

const watchPatchSelectedPromoFinancingSaga = function* watchPatchSelectedPromoFinancingSaga() {
    yield takeLatest(
        paymentActionTypes.PATCH_SELECTED_PROMO_FINANCING_OFFER,
        patchSelectedPromoFinancingSaga
    );
};
watchPatchSelectedPromoFinancingSaga.sagaName = 'watchPatchSelectedPromoFinancingSaga';

function* postSelectedRewardOrFinancingSaga(action) {
    try {
        yield put(showGlobalLoader(true));
        const result = yield call(FactorySaga, postRewardOrFinancing, action);
        if (result.isSuccess) {
            const draftOrderInfo = yield select(orderDetailsSelector);
            if (window.location.pathname === URL_REVIEW_PAGE) {
                // If user is already in the review page then just refresh the content
                // to reflect the selection made by the user
                yield put(cartActions.getCartDetails());
            } else {
                // If user is in payment page redirect to the review page
                yield put(cartActions.getCartDetails(reviewPage()));
            }
            let rewardPromoFinanceData = {};
            if (action.payload && action.payload.isPromoFinanceSelected) {
                // TODO get id from adject state based NEWCUSTOMER
                const adjustmentList = get(draftOrderInfo, 'data.adjustments', []);
                const ids = [];
                map(adjustmentList, (adjustment) => {
                    adjustment.rewardCategory === ADJUSTMENT_TYPE_NEW_CUSTOMER &&
                        ids.push(adjustment.id);
                });
                rewardPromoFinanceData = {
                    isSpecialFinancingSelected: true,
                    isRewardRemoved: true,
                    rewardPercentage: action.payload.rewardPercentageOff,
                };
                const adjustmentResponse = {
                    ids,
                };
                yield put({ type: DELETE_REWARD_REQUEST_SUCCESS, adjustmentResponse });
            }
            if (action.payload && action.payload.specialDiscountApplied) {
                rewardPromoFinanceData = {
                    specialDiscountApplied: true,
                };
            }
            if (!isEmpty(rewardPromoFinanceData)) {
                yield put(paymentAction.setRewardPromoFinanceDecisionData(rewardPromoFinanceData));
            }
        } else {
            yield put(PlaceOrderActions.resetPromoFinancingData());
        }
    } catch (error) {
        yield put(cartActions.getCartDetails(reviewPage()));
    }
}

const watchpostSelectedRewardOrFinancingSaga = function* watchpostSelectedRewardOrFinancingSaga() {
    yield takeLatest(
        paymentActionTypes.POST_SELECTED_REWARD_OR_FINANCING_OFFER,
        postSelectedRewardOrFinancingSaga
    );
};
watchpostSelectedRewardOrFinancingSaga.sagaName = 'watchpostSelectedRewardOrFinancingSaga';

export {
    watchGetPromoFinancingSaga,
    watchPatchSelectedPromoFinancingSaga,
    watchpostSelectedRewardOrFinancingSaga,
};
